import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Subject} from 'rxjs';
import {ScheduleListProvider, ScheduleProcedureTO} from 'cw-backend';
import {
    FuseConfirmDialogComponent
} from '../../../../../../../@fuse/components/confirm-dialog/confirm-dialog.component';
import {Router} from '@angular/router';
import {guiaModal} from '../../../reception/os/os.component';
import {ReportProvider} from '../../../../../../../../shared/cw-backend/providers/application/report/report.provider';
import {FuseProgressBarService} from '../../../../../../../@fuse/components/progress-bar/progress-bar.service';
import {SnackBarService} from 'cw-utils';

// @ts-ignore
@Component({
    selector: 'cw-schedule-dialog-os-procedure',
    templateUrl: './schedule-dialog-os-procedure.component.html',
    styleUrls: ['./schedule-dialog-os-procedure.component.scss']
})
export class ScheduleDialogOsProcedureComponent implements OnInit {

    public loadingButton: boolean = false;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    procedureList = new Array<any>();
    schedule: any;
    scheduleOrderList = new Array<any>();
    details: boolean = false;
    noOs = false
    displayedColumns: string[] = ['procedure', 'action'];
    patientId:number;

    constructor(
        public _matDialogRef: MatDialogRef<ScheduleDialogOsProcedureComponent>,
        private scheduleListProvider: ScheduleListProvider,
        private reportProvider: ReportProvider,
        private _router: Router,
        private _matDialog: MatDialog,
        private progressBar: FuseProgressBarService,
        private snackBar: SnackBarService,
        @Inject(MAT_DIALOG_DATA) private _data: any,
    ) { }

    ngOnInit(): void {
        if (this.details){
            this.schedule = this._data;
            this.patientId = this.schedule.patient.id;
            console.log(this.schedule);
            this.checkGuide();
        }else{
            this.procedureList = this._data;
        }
    }

    async checkGuide(){
        let so = {
            procedure: this.schedule.procedure,
            orderId: await this.checkScheduleProcedure(this.schedule.id),
            scheduleId: this.schedule.id
        }

        let list = new Array<any>();
        list.push(so)

        for (const scheprod of this.schedule.scheduleProcedureList) {
            let sop = {
                procedure: scheprod.procedure,
                orderId: await this.checkScheduleProcedure(scheprod.id),
                scheduleId: scheprod.id
            }
            list.push(sop)
        }
        this.scheduleOrderList = [...list]; //

        const result = this.scheduleOrderList.findIndex(s => s.orderId > 0);
        if (result < 0) { this.noOs = true; }

    }

    async checkScheduleProcedure(scheduleId){
        return new Promise((resolve, reject) => {
            this.scheduleListProvider
                .checkScheduleOrder(scheduleId)
                .then((res)=>{
                    resolve(res.body);
                })

        });
    }

    async confirmNavigateOrder(type,scheduleId, orderId) {
        let scheduleResult;
        let schedule;
        if (type ===  "new"){
            scheduleResult = await this.scheduleListProvider.getScheduleById(scheduleId);
            schedule = scheduleResult.body;
        }
        let navigate = "";
        switch (type) {
            case "print":
                this.generateReportOS(orderId);
                break;
            case "list":
                navigate = `operacional/recepcao/os/${this.patientId}`;
                this._router.navigate([navigate]);
                this.dimiss("N")
                break;
            case "os":
                navigate = `operacional/recepcao/os/manter/${this.patientId}/${orderId}`;
                this._router.navigate([navigate]);
                this.dimiss("N")
                break;
            case "new":
                this._router.navigate([
                    `operacional/recepcao/os/manter/${this.patientId}/new`,
                ]);
                localStorage.setItem(
                    "scheduleOs",
                    JSON.stringify(scheduleResult.body)
                );
                navigate = `operacional/recepcao/os/manter/${this.patientId}/${orderId}`;
                this.dimiss("N")
                break;
            default:
                break;
        }


    }

    generateReportOS(orderId: number) {
        this.snackBar.successMessage("Gerando guia aguarde...");

        this.reportProvider.getPdfGuide(orderId).then((x) => {
            let pdfSrc = x.pdf as string;

            var newBlob = new Blob([x], { type: "application/pdf" });

            const nav = window.navigator as any;

            if (nav && nav.msSaveOrOpenBlob) {
                nav.msSaveOrOpenBlob(newBlob);
                return;
            }

            this.progressBar.hide();
            const dialogRef = this._matDialog.open(guiaModal, {
                height: "100%",
                width: "120%",
                data: pdfSrc,
            });

            dialogRef.afterClosed().subscribe((result) => {
                pdfSrc = null;
            });
        });
    }


    dimiss(type: string): void {
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
        this._matDialogRef.close(type);
    }
}
